module.exports = __webpack_public_path__ + "img/feature_c05.321c29ee.svg";